<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <div
      class="form_title_wrapper d-flex justify-content-between align-items-center"
    >
      <h4>{{ $t("PLACEHOLDERS.pdf") }}</h4>
      <div class="actions d-flex align-items-center">
        <button class="btn_show mx-2" @click="$router.go(-1)">
          <i class="fas fa-backward"></i>
        </button>
        <button
          class="btn_show mx-2"
          :disabled="loading || !pdfUrl"
          @click="printInvoice"
        >
          <i class="fas fa-print"></i>
        </button>
        <button
          class="btn_show mx-2"
          :disabled="loading || !pdfUrl"
          @click="downloadInvoice"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </div>

    <div class="single_step_form_content_wrapper">
      <div v-if="loading" class="text-center py-5">
        {{ $t("TABLES.loadingData") }}
      </div>

      <div v-else-if="errorMessage" class="text-center text-danger py-5">
        {{ errorMessage }}
      </div>

      <iframe
        v-else-if="pdfUrl"
        ref="invoiceFrame"
        :src="pdfUrl"
        style="width: 100%; min-height: 80vh; border: 0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "DonationInvoice",

  data() {
    return {
      loading: false,
      pdfUrl: null,
      errorMessage: null,
    };
  },

  methods: {
    async getInvoicePdf() {
      this.loading = true;
      this.errorMessage = null;

      try {
        const res = await this.$axios({
          method: "GET",
          url: `donations/${this.$route.params.id}/invoice`,
          responseType: "blob",
        });

        const contentType =
          (res.headers && res.headers["content-type"]) || "application/pdf";
        if (contentType.includes("application/json")) {
          this.errorMessage = this.$t("TABLES.noData");
          return;
        }

        const blob = new Blob([res.data], { type: contentType });
        this.pdfUrl = window.URL.createObjectURL(blob);
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message || this.$t("TABLES.noData");
      } finally {
        this.loading = false;
      }
    },

    printInvoice() {
      if (!this.pdfUrl) {
        return;
      }
      const frame = this.$refs.invoiceFrame;
      if (frame && frame.contentWindow) {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      }
    },

    downloadInvoice() {
      if (!this.pdfUrl) {
        return;
      }
      const link = document.createElement("a");
      link.href = this.pdfUrl;
      link.download = `donation-${this.$route.params.id}-invoice.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },

  created() {
    this.getInvoicePdf();
  },

  beforeDestroy() {
    if (this.pdfUrl) {
      window.URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>
